module.exports = __webpack_public_path__ + "media/images/edm_banner-78a259e12fd43ad7067e9d8bbd2b886c.jpg";